export const APP_ROUTES = {
   SPLASH: "/get-started",
   LOGIN: "/auth/login",
   FORGET_PASSWORD: "/auth/forgot-password",
   FORGET_VERIFY_CODE: "/auth/forget-verify-code",
   RESET_PASSWORD: "/auth/reset-password",
   DASHBOARD: "/dashboard",
   USER_PROFILE: "/profile",
   SETTINGS: "/settings",
   INVENTORY: "/inventory",
   INVENTORY_REQUEST: "/inventory-request",
   ORDER_MANAGEMENT: "/order-management",
   INVENTORY_MANAGEMENT: "/inventory-management",
   USER_MANAGEMENT: "/user-management",
   VENDOR_MANAGEMENT: "/vendor-management",
   VENDOR_MANAGEMENT_DETAILS: "/vendor-management/:vendorId",
   FAQS: "/faqs",
   // Locations
   LOCATION: "/locations",
   ADMIN_LOCATION_WAREHOUSE: "/locations/warehouse",
   ADMIN_LOCATION_DEPARTMENT: "/locations/station",
   ADMIN_LOCATION_DEPARTMENT_ITEM_CATALOG:
      "/locations/station/:departmentId/item-catalog",
   ADMIN_ORDER_MANAGEMENT: "/admin-order-management",
   INVENTORY_WAREHOUSE: "/inventory/warehouse",
   INVENTORY_DEPARTMENT: "/inventory/station",
   INVENTORY_WAREHOUSE_GI: "/inventory/warehouse/gi",
   INVENTORY_WAREHOUSE_CHEMICALS: "/inventory/warehouse/chemicals",
   INVENTORY_WAREHOUSE_TOOLS: "/inventory/warehouse/tools",
   INVENTORY_DEPARTMENT_GI: "/inventory/station/gi",
   INVENTORY_DEPARTMENT_CHEMICALS: "/inventory/station/chemicals",
   INVENTORY_DEPARTMENT_TOOLS: "/inventory/station/tools",
   INVENTORY_REQUEST_DEPARTMENT: "/inventory-request/station",
   INVENTORY_REQUEST_PULLBACK: "/inventory-request/transfer-inventory",
   INVENTORY_REQUEST_SCRAP: "/inventory-request/scrap",
   // Trailers Management
   TRAILERS_MANAGEMENT: "/manage/type",
   TRAILERS_MANAGEMENT_ADD_TRAILER: "/manage/type/add",
   TRAILERS_MANAGEMENT_TRAILER_DETAILS: "/manage/type/:trailerId",
   TRAILERS_MANAGEMENT_UPDATE_TRAILER: "/manage/type/:trailerId/update",
   TRAILERS_MANAGEMENT_CLONE_TRAILER: "/manage/type/:trailerId/clone",
   // Trailer
   ORDERED_TRAILERS: "/ordered-trailers",
   //Timeline
   TIMELINE: "/timeline",
   TIMELINE_CONFIGURATOR_ORDERS: "/timeline/ordered-trailers",
   TIMELINE_CONFIGURATOR_ORDER_DETAILS: "/timeline/ordered-trailers/:id",
   TIMELINE_ALL_ORDERS: "/timeline/all-orders",
   TIMELINE_PRODUCTION_SCHEDULE: "/timeline/production-schedule",
   // Configurator
   CONFIGURATOR: "/configurator",
   CONFIGURATOR_TRAILERS: "/configurator/trailers",
   CONFIGURATOR_TRAILER_SETTINGS: "/configurator/trailer/:trailerId",
   CONFIGURATOR_TRAILER_SETTINGS_BUILD:
      "/configurator/trailer/:trailerId/build",
   CONFIGURATOR_TRAILER_SETTINGS_BUILD_STATION_ITEMS:
      "/configurator/trailer/:trailerId/build/:buildId/:stationId/items/:stationName",
   CONFIGURATOR_TRAILER_SETTINGS_BASE_FEATURES:
      "/configurator/trailer/:trailerId/base-features",
   CONFIGURATOR_TRAILER_SETTINGS_BASE_FEATURES_ITEMS:
      "/configurator/trailer/:trailerId/base-features/:categoryId/items/:categoryName",
   CONFIGURATOR_TRAILER_SETTINGS_PACKAGES:
      "/configurator/trailer/:trailerId/packages",
   CONFIGURATOR_TRAILER_SETTINGS_PACKAGES_ITEMS:
      "/configurator/trailer/:trailerId/packages/:packageId/items/:packageName",
   CONFIGURATOR_TRAILER_SETTINGS_CUSTOMIZATION:
      "/configurator/trailer/:trailerId/personalization",
   CONFIGURATOR_TRAILER_SETTINGS_CUSTOMIZATION_ITEMS:
      "/configurator/trailer/:trailerId/personalization/:categoryId/items/:categoryName",
   CONFIGURATOR_TRAILER_SETTINGS_EQUIPMENTS:
      "/configurator/trailer/:trailerId/equipment",
   CONFIGURATOR_TRAILER_SETTINGS_EQUIPMENT_ITEMS:
      "/configurator/trailer/:trailerId/equipment/:categoryId/items/:categoryName",
   CONFIGURATOR_TRAILER_SETTINGS_SUMMARY:
      "/configurator/trailer/:trailerId/summary",
   CONFIGURATOR_TRAILER_SETTINGS_SUMMARY_SALES_MARKETING:
      "/configurator/trailer/:trailerId/summary/sales-marketing",
   CONFIGURATOR_TRAILER_SETTINGS_SUMMARY_BUILD:
      "/configurator/trailer/:trailerId/summary/build",
   CONFIGURATOR_TRAILER_SETTINGS_SUMMARY_GENERAL_SETTINGS:
      "/configurator/trailer/:trailerId/summary/general-settings",
   // Production  Line
   PRODUCTION_LINE_MANAGEMENT: "/production",
   PRODUCTION_LINE_MANAGEMENT_LISTING: "/production/production-lines",
   PRODUCTION_LINE_MANAGEMENT_MOULD: "/production/moulds",

   PRODUCTION_LINE_MANAGEMENT_DETAILS:
      "/production/production-lines/:productionLineId",
   PRODUCTION_LINE_MANAGEMENT_DETAILS_OVERRIDES:
      "/production/production-lines/:productionLineId/overrides",
   PRODUCTION_LINE_MANAGEMENT_DETAILS_STAGES:
      "/production/production-lines/:productionLineId/stages",

   CONFIGURATOR_TRAILER_SETTINGS_PACKAGES_WARRANTY:
      "/configurator/trailer/:trailerId/warranty",
   // Count Sheet
   COUNT_SHEET: "/countsheets",
   COUNT_SHEET_STATIONS: "/countsheets/stations",
   COUNT_SHEET_WAREHOUSE: "/countsheets/warehouse",
}

export const getRoute = (route, obj = {}) => {
   if (Object.keys(obj).length) {
      let objectKeys = Object.keys(obj)
      objectKeys.forEach(item => {
         route = route.replace(new RegExp(/:([\d\w?])+/, "i"), match => {
            let formattedMatchedValue =
               match[match.length - 1] === "?"
                  ? match.slice(1, match.length - 1)
                  : match.slice(1)
            return obj[formattedMatchedValue]
         })
      })

      return route
   }

   return route
}
